import moment from "moment"
import { APP_DATE_FORMAT } from "../config"

export const isValid = (date)=>{
    return moment(date).isValid
}

export const getSystemDate=(date, desiredFormat)=>{
    return isValid(date) ? moment(date).format(desiredFormat ? desiredFormat: APP_DATE_FORMAT) : date;
}